import { render, staticRenderFns } from "./BookmarkFilled.vue?vue&type=template&id=350e2e54&"
import script from "./BookmarkFilled.vue?vue&type=script&lang=js&"
export * from "./BookmarkFilled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports